import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  DestroyRef,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fadeOut } from '@core/animations/fadeOut';
import { DebugIndicatorComponent } from '@core/components/atoms/debug-indicator/debug-indicator.component';
import { BlankLayoutComponent } from '@core/layout/blank/blank.component';
import { PageLayout } from '@core/layout/layout.interface';
import { PageLayoutService } from '@core/layout/layout.service';
import { MainLayoutComponent } from '@core/layout/main/main.component';
import { DebugService } from '@core/services/debug/debug.service';
import { ColorModeService } from '@core/services/color-mode.service';
import { LoadingService } from '@core/services/loading.service';
import { PalantirModule, PalantirToastComponent } from '@flux/design-system';
import { RealtimeService } from './core/services/realtime/realtime.service';

// declare const monaco: any; // Se você não tem as tipagens do monaco-editor instaladas ou configuradas globalmentedeclare const monaco: any; // Mantenha isso se necessário

(window as any).MonacoEnvironment = {
  getWorkerUrl: function (moduleId: string, label: string) {
    // Definimos o caminho base absoluto para onde os assets do Monaco foram copiados.
    // O '/' no início garante que é um caminho absoluto a partir da raiz do seu domínio.
    const baseMonacoPath = '/assets/monaco/'; // <-- Adicionei um '/' no início aqui

    if (label === 'json') {
      return `${baseMonacoPath}vs/language/json/json.worker.js`;
    }
    if (label === 'css' || label === 'scss' || label === 'less') {
      return `${baseMonacoPath}vs/language/css/css.worker.js`;
    }
    if (label === 'html' || label === 'handlebars' || label === 'razor') {
      return `${baseMonacoPath}vs/language/html/html.worker.js`;
    }
    if (label === 'typescript' || label === 'javascript') {
      return `${baseMonacoPath}vs/language/typescript/ts.worker.js`;
    }
    // Worker padrão para o editor em geral
    return `${baseMonacoPath}vs/editor/editor.worker.js`;
  },
};

@Component({
  selector: 'app-root',
  imports: [
    BlankLayoutComponent,
    MainLayoutComponent,
    CommonModule,
    PalantirModule,
    PalantirToastComponent,
    DebugIndicatorComponent,
  ],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeOut],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent implements OnInit {
  public pageLayout = signal<PageLayout | null>('blank');

  constructor(
    public readonly pageLayoutService: PageLayoutService,
    public readonly loadingService: LoadingService,
    public readonly destroyRef: DestroyRef,
    private readonly _: DebugService,
    private readonly __: RealtimeService,
    // Instancia no bootstrap para aplicar o tema persistido (data-theme) em TODA tela —
    // inclusive sign-in/sign-up, que ficam fora do shell logado (onde o toggle vive).
    private readonly ___: ColorModeService,
  ) {}

  ngOnInit(): void {
    this.pageLayoutService.layout$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((layout) => {
      this.pageLayout.set(layout);
    });
  }
}
